module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_03-bb8e66ef8694abcc10b90622eabafc8b.png";